export default function unclipBox(box, elements) {
    elements.forEach(element => {
        const options = element && element.options;
        const elBox = element && (element.box || element.wrapperBox);
        if (options && elBox && options.noclip !== false && options.visible !== false && !options.visual) {
            box.wrap(elBox);
        }
    });
    return box;
}